export const getBrowserLang = () => {
  const browserLang = window.navigator.language;
  return browserLang ? browserLang.split("-")[0] : "de";
};

export const getAltLang = (lang: "de" | "en") => (lang === "de" ? "en" : "de");
